import React, { Component } from "react";
import { Col, Form, Row, Button, Alert, Card } from "react-bootstrap";
import configData from "../config.json";
import { toast } from "react-toastify";

// SATP-specific add-on configuration - only liability covers applicable
const satpAddonConfig = {
    "Third Party Property Damage": {
        key: "add_tppd",
        type: "checkbox",
        mandatory: true,
        defaultChecked: true,
        description: "Mandatory TPPD cover for third party property damage",
        conditionalFields: [
            {
                label: "Third Party Property Damage Sum Insured",
                name: "add_tppd_si",
                type: "select",
                options: ["6000", "7500000"],
                defaultValue: "6000",
                condition: true,
                note: "Default SI: ₹6,000 (can be enhanced to ₹75,00,000)",
            },
        ],
    },
    "Personal Accident Owner-Driver": {
        key: "add_pa_owner",
        type: "checkbox",
        mandatory: true,
        defaultChecked: true,
        description: "Mandatory PA cover for owner-driver",
        conditionalFields: [
            {
                label: "PA Owner Sum Insured",
                name: "add_pa_owner_si",
                type: "select",
                options: ["1500000", "2000000", "2500000"],
                defaultValue: "1500000",
                condition: true,
                note: "Default SI: ₹15,00,000",
            },
        ],
    },
    "Personal Accident Paid Driver": {
        key: "pa_paid",
        type: "checkbox",
        mandatory: false,
        description: "Optional PA cover for paid driver",
        conditionalFields: [
            {
                label: "Number of Paid Drivers",
                name: "pa_paid_no",
                type: "select",
                options: ["1", "2", "3"],
                condition: (state) => state.pa_paid === true,
            },
            {
                label: "PA Paid Driver Sum Insured",
                name: "pa_paid_si",
                type: "select",
                options: ["100000", "200000", "300000", "500000"],
                defaultValue: "100000",
                condition: (state) => state.pa_paid === true,
                note: "SI per driver",
            },
        ],
    },
    "Personal Accident Unnamed Passengers": {
        key: "pa_unnamed",
        type: "checkbox",
        mandatory: false,
        description: "Optional PA cover for unnamed passengers",
        conditionalFields: [
            {
                label: "Number of Unnamed Passengers",
                name: "pa_unnamed_no",
                type: "select",
                options: ["1", "2", "3", "4", "5"],
                condition: (state) => state.pa_unnamed === true,
            },
            {
                label: "PA Unnamed Sum Insured",
                name: "pa_unnamed_si",
                type: "select",
                options: ["100000", "200000", "300000"],
                defaultValue: "100000",
                condition: (state) => state.pa_unnamed === true,
                note: "SI per passenger",
            },
        ],
    },
    "Legal Liability Paid Driver": {
        key: "ll_paid",
        type: "checkbox",
        mandatory: false,
        description: "Legal liability for paid driver (Workmen Compensation Act)",
        conditionalFields: [
            {
                label: "Number of Paid Drivers for LL",
                name: "ll_paid_no",
                type: "select",
                options: ["1", "2", "3"],
                condition: (state) => state.ll_paid === true,
            },
        ],
    },
    "Legal Liability Employees": {
        key: "ll_emp",
        type: "checkbox",
        mandatory: false,
        description: "Legal liability for employees (other than driver)",
        conditionalFields: [
            {
                label: "Number of Employees",
                name: "ll_emp_no",
                type: "select",
                options: ["1", "2", "3", "4", "5"],
                condition: (state) => state.ll_emp === true,
            },
        ],
    },
};

export default class MQuotesaddons extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Session data
            sId: sessionStorage.getItem("sessionId"),
            uId: sessionStorage.getItem("uId"),
            business_type: sessionStorage.getItem("business_type"),
            proposer_type: sessionStorage.getItem("proposer_type"),
            plan_type: sessionStorage.getItem("plan_type"),
            pol_start_date: sessionStorage.getItem("pol_start_date"),
            prev_pol_start_date: sessionStorage.getItem("prev_pol_start_date"),
            prev_pol_end_date: sessionStorage.getItem("prev_pol_end_date"),
            bletpstart: sessionStorage.getItem("bletpstart"),
            bletpend: sessionStorage.getItem("bletpend"),
            bleodstart: sessionStorage.getItem("bleodstart"),
            bleodend: sessionStorage.getItem("bleodend"),

            // UI state
            isSubmittingAddons: false,
            integId: 327,

            // Addon management
            addonValues: this.initializeMandatorySATPAddons(),

            // Quote details from previous page
            quoteDetails: null,

            // Current addons applied (for edit mode)
            currentAddons: null,
            isEditMode: false,
        };
    }

    componentDidMount() {
        this.loadQuoteDetails();
        this.checkExistingAddons();
    }

    // Initialize mandatory SATP add-ons
    initializeMandatorySATPAddons = () => {
        return {
            add_tppd: true,
            add_tppd_si: "6000",
            add_pa_owner: true,
            add_pa_owner_si: "1500000"
        };
    };

    loadQuoteDetails = () => {
        const storedQuoteDetails = sessionStorage.getItem("quoteDetailsForAddons");
        if (storedQuoteDetails) {
            try {
                const quoteDetails = JSON.parse(storedQuoteDetails);
                this.setState({ quoteDetails });
            } catch (error) {
                console.error("Error parsing quote details:", error);
                this.showToast("Error loading quote details", "error");
            }
        } else {
            this.showToast("No quote details found. Please go back to quotes page.", "warning");
        }
    };

    checkExistingAddons = () => {
        // Check if user is coming back to edit existing addon selection
        const existingAddonData = sessionStorage.getItem("currentAddonSelection");
        if (existingAddonData) {
            try {
                const addonData = JSON.parse(existingAddonData);
                this.setState({
                    addonValues: addonData,
                    currentAddons: addonData,
                    isEditMode: true
                });
                this.showToast("Loaded your current addon selection for editing", "info");
            } catch (error) {
                console.error("Error loading existing addon data:", error);
            }
        }
    };

    showToast = (msg, type = "success") => {
        const toastMethods = {
            success: toast.success,
            error: toast.error,
            warning: toast.warn,
            info: toast.info
        };
        toastMethods[type](msg);
    };

    getTenureFromPlan = (plan) => {
        if (!plan) return "1";
        if (plan.includes("1 year")) return "1";
        if (plan.includes("2 years")) return "2";
        if (plan.includes("3 years")) return "3";
        if (plan.includes("5 years")) return "5";
        return "1";
    };

    // Validate SATP add-ons before submission
    validateSATPAddons = () => {
        const { addonValues = {} } = this.state;
        const errors = [];

        // Check each selected add-on for required conditional fields
        Object.values(satpAddonConfig).forEach(addon => {
            if (addonValues[addon.key] === true && addon.conditionalFields) {
                addon.conditionalFields.forEach(field => {
                    const showField = typeof field.condition === "function"
                        ? field.condition(addonValues)
                        : field.condition;

                    if (showField && field.required && !addonValues[field.name]) {
                        const addonName = Object.keys(satpAddonConfig).find(name =>
                            satpAddonConfig[name].key === addon.key
                        );
                        errors.push(`${field.label} is required for ${addonName}`);
                    }
                });
            }
        });

        return {
            isValid: errors.length === 0,
            errors
        };
    };

    // Submit add-on request
    submitAddonRequest = () => {
        if (this.state.isSubmittingAddons) {
            this.showToast("Request already in progress", "warning");
            return;
        }

        // Validate SATP add-ons
        const validation = this.validateSATPAddons();
        if (!validation.isValid) {
            this.showToast(validation.errors[0], "error");
            return;
        }

        // For SATP, check if any optional add-ons are selected
        const optionalAddons = Object.keys(this.state.addonValues || {}).filter(key => {
            const addon = Object.values(satpAddonConfig).find(config => config.key === key);
            return this.state.addonValues[key] === true && addon && !addon.mandatory;
        });

        if (optionalAddons.length === 0) {
            this.showToast("Proceeding with mandatory covers only", "info");
        }

        this.setState({ isSubmittingAddons: true });

        const jsonData = this.buildAddonRequestData();
        console.log("SATP Add-on request data:", JSON.stringify(jsonData, null, 2));

        const formData = new FormData();
        formData.append("sId", this.state.sId);
        formData.append("uId", this.state.uId);
        formData.append("integId", 327);
        formData.append("savedata", "yes");
        formData.append("jsonData", JSON.stringify(jsonData));

        fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
            method: "POST",
            body: formData,
        })
            .then((response) => response.json())
            .then((responseData) => {
                console.log("Add-on submission response:", responseData);

                if (responseData.status === "success") {
                    sessionStorage.setItem("QrequestId", responseData.requestId);

                    // Save current addon selection for future edits
                    sessionStorage.setItem("currentAddonSelection", JSON.stringify(this.state.addonValues));

                    this.showToast("SATP liability add-ons submitted successfully", "success");

                    // Wait for processing and then fetch updated quote
                    setTimeout(() => {
                        this.fetchAddonQuote();
                    }, 10000);
                } else {
                    this.setState({ isSubmittingAddons: false });
                    this.showToast(responseData.message || "Failed to submit add-on request", "error");
                }
            })
            .catch((error) => {
                this.setState({ isSubmittingAddons: false });
                console.error("Error submitting add-on request:", error);
                this.showToast("Error submitting add-on request", "error");
            });
    };

    buildAddonRequestData = () => {
        const { addonValues = {}, quoteDetails = {} } = this.state;

        // Helper function to safely get string values
        const safeString = (value) => value ? String(value) : "";
        const safeBool = (value) => value ? "true" : "false";

        return {
            quote_id: safeString(quoteDetails.quote_id),
            vehicle_idv: safeString(quoteDetails.vehicle_idv),
            q_producer_code: "4984727878",
            q_producer_email: "krutika.qualitykiosk@tataaig.com",
            q_office_location: "90110",
            pol_tenure: this.getTenureFromPlan(this.state.plan_type),
            business_type: safeString(this.state.business_type),
            is_posp: "N",
            q_agent_pan: "",
            sol_id: "",
            proposer_type: safeString(this.state.proposer_type) || "Individual",
            plan_type: safeString(this.state.plan_type),
            fleet_policy: "false",
            fleet_code: "",
            fleet_name: "",
            pol_start_date: safeString(this.state.pol_start_date),
            pa_owner: "false",
            pa_owner_tenure: "",
            pa_owner_declaration: "Owner driver does not hold valid Driving license",
            driver_age: "",
            driver_gender: "",
            driver_occupation: "",
            claim_last: "false",
            claim_last_count: "",
            claim_last_amount: "",
            pre_pol_ncb: safeString(quoteDetails.pre_pol_ncb),
            no_past_pol: "false",
            prev_pol_start_date: safeString(this.state.prev_pol_start_date),
            prev_pol_end_date: safeString(this.state.prev_pol_end_date),
            prev_pol_type: "PackagePolicy",
            rtn_invoice: "false",
            cng_lpg: "false",
            dep_reimb: "false",
            ble_tp_start: safeString(this.state.bletpstart),
            ble_tp_end: safeString(this.state.bletpend),
            ble_od_start: safeString(this.state.bleodstart),
            ble_od_end: safeString(this.state.bleodend),
            special_regno: "false",
            regno_1: safeString(sessionStorage.getItem("regno_1")),
            regno_2: safeString(sessionStorage.getItem("regno_2")),
            regno_3: safeString(sessionStorage.getItem("regno_3")),
            regno_4: safeString(sessionStorage.getItem("regno_4")),
            place_reg: safeString(quoteDetails.place_reg),
            place_reg_no: safeString(quoteDetails.place_reg_no),
            proposer_pincode: safeString(quoteDetails.proposer_pincode),
            vehicle_make: safeString(quoteDetails.vehicle_make),
            vehicle_model: safeString(quoteDetails.vehicle_model),
            vehicle_variant: safeString(quoteDetails.vehicle_variant),
            dor: safeString(quoteDetails.dor),
            man_year: safeString(quoteDetails.man_year),
            manu_month: safeString(quoteDetails.manu_month),
            make_code: safeString(quoteDetails.make_code),
            model_code: safeString(quoteDetails.model_code),
            variant_code: safeString(quoteDetails.variant_code),

            // Default fields for comprehensive coverage (not applicable for SATP)
            veh_plying_city: "",
            side_car: "false",
            side_car_idv: "",
            non_electrical_acc: "false",
            non_electrical_si: "",
            non_electrical_des: "",
            electrical_acc: "false",
            electrical_si: "",
            electrical_des: "",
            cng_lpg_cover: "false",
            cng_lpg_si: "",
            automobile_association_cover: "false",
            automobile_association_mem_exp_date: "",
            automobile_association_mem_no: "",
            antitheft_cover: "false",
            vehicle_blind: "false",
            own_premises: "false",
            driving_tution: "false",
            tppd_discount: "false",
            voluntary_deductibles: "false",
            voluntary_deductibles_amt: "",
            uw_discount: "",
            uw_loading: "",

            // SATP-specific liability add-ons
            add_tppd: safeBool(addonValues.add_tppd),
            add_tppd_si: safeString(addonValues.add_tppd_si) || "6000",
            add_pa_owner: safeBool(addonValues.add_pa_owner),
            add_pa_owner_si: safeString(addonValues.add_pa_owner_si) || "1500000",
            pa_paid: safeBool(addonValues.pa_paid),
            pa_paid_no: safeString(addonValues.pa_paid_no),
            pa_paid_si: safeString(addonValues.pa_paid_si),
            pa_unnamed: safeBool(addonValues.pa_unnamed),
            pa_unnamed_no: safeString(addonValues.pa_unnamed_no),
            pa_unnamed_si: safeString(addonValues.pa_unnamed_si),
            ll_paid: safeBool(addonValues.ll_paid),
            ll_paid_no: safeString(addonValues.ll_paid_no),
            ll_emp: safeBool(addonValues.ll_emp),
            ll_emp_no: safeString(addonValues.ll_emp_no),

            // Set OD add-ons to false for SATP
            dep_reimburse: "false",
            dep_reimburse_claims: "",
            dep_reimburse_deductible: "",
            return_invoice: "false",
            consumbale_expense: "false",
            add_towing: "false",
            add_towing_amount: "",
            rsa: "false",
            emg_med_exp: "false",
            emg_med_exp_si: "",

            // Additional default fields
            add_pa_unnamed: "false",
            add_pa_unnamed_si: "",
            vehicle_trails_racing: "false",
            event_name: "",
            promoter_name: "",
            event_from_date: "",
            event_to_date: "",
            ext_racing: "false",
            imported_veh_without_cus_duty: "false",
            fibre_fuel_tank: "false",
            loss_accessories: "false",
            loss_accessories_idv: "",
            geography_extension: "false",
            geography_extension_bang: "false",
            geography_extension_bhutan: "false",
            geography_extension_lanka: "false",
            geography_extension_maldives: "false",
            geography_extension_nepal: "false",
            geography_extension_pak: "false",
            __finalize: "1",
        };
    };

    // Fetch updated quote with add-ons
    fetchAddonQuote = () => {
        const formData = new FormData();
        formData.append("sId", this.state.sId);
        formData.append("uId", this.state.uId);
        formData.append("integId", this.state.integId);
        formData.append("requestId", sessionStorage.getItem("QrequestId"));

        fetch(configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId", {
            method: "POST",
            mode: "cors",
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                console.log("Add-on Quote Response:", JSON.stringify(data, null, 2));
                this.processAddonQuoteResponse(data);
            })
            .catch((error) => {
                console.error("Error fetching add-on quote:", error);
                this.showToast("Error fetching add-on quote", "error");
            })
            .finally(() => {
                this.setState({ isSubmittingAddons: false });
            });
    };

    processAddonQuoteResponse = (data) => {
        if (data.status === "success" && data.data) {
            try {
                const responseData = data.data;

                if (responseData.status && responseData.status < 0) {
                    this.showToast(responseData.message_txt || "Error in add-on quote", "error");
                    return;
                }

                const addonQuoteData = responseData.data;
                if (!addonQuoteData) {
                    this.showToast("No add-on quote data received", "error");
                    return;
                }

                // Store updated proposal ID
                if (addonQuoteData.proposal_id) {
                    sessionStorage.setItem("proposal_id", addonQuoteData.proposal_id);
                }

                // Process and normalize add-on quote data
                const normalizedAddonQuote = this.normalizeQuoteData(addonQuoteData, responseData);

                // Store updated quote data for main quotes page
                sessionStorage.setItem("updatedQuoteData", JSON.stringify(normalizedAddonQuote));

                this.showToast("Updated SATP quote with liability add-ons ready!", "success");

                setTimeout(() => {
                    // Navigate back to quotes page to show updated quote
                    window.location.href = "/mquotes";
                }, 2000);

            } catch (error) {
                console.error("Error processing add-on quote:", error);
                this.showToast("Error processing add-on quote data", "error");
            }
        } else {
            this.showToast("Failed to get updated quote with add-ons", "warning");
        }
    };

    // Normalize quote data structure (same as main quotes page)
    normalizeQuoteData = (quoteData, responseData) => {
        const premiumBreakup = quoteData.premium_break_up || {};
        const dataSection = quoteData.data || {};
        const polDetails = quoteData.pol_dlts || {};

        return {
            // Basic quote info
            quote_id: quoteData.quote_id,
            proposal_id: quoteData.proposal_id,
            policy_id: quoteData.policy_id,
            quote_no: quoteData.quote_no,
            business_type: quoteData.business_type,
            proposer_type: quoteData.proposer_type,
            plan_type: quoteData.plan_type,
            pol_start_date: quoteData.pol_start_date,
            pol_end_date: quoteData.pol_end_date,

            // Vehicle details
            vehicle_make: quoteData.vehicle_make,
            vehicle_model: quoteData.vehicle_model,
            vehicle_variant: quoteData.vehicle_variant,
            dor: quoteData.dor,
            man_year: quoteData.man_year,
            regno_1: quoteData.regno_1,
            regno_2: quoteData.regno_2,
            regno_3: quoteData.regno_3,
            regno_4: quoteData.regno_4,
            place_reg: quoteData.place_reg,
            vehicle_idv: dataSection.vehicle_idv || polDetails.vehicle_idv || 0,

            // Premium details
            net_premium: this.extractNetPremium(premiumBreakup, dataSection, polDetails),
            total_premium: this.extractTotalPremium(premiumBreakup, dataSection, polDetails),
            gst_amount: this.extractGSTAmount(premiumBreakup, dataSection, polDetails),

            // Store original data for reference
            raw_data: quoteData,
            premium_break_up: premiumBreakup,
            data: dataSection,
            pol_dlts: polDetails
        };
    };

    extractNetPremium = (premiumBreakup, dataSection, polDetails) => {
        return premiumBreakup.net_premium ||
            dataSection.net_premium ||
            polDetails.net_premium ||
            premiumBreakup.basic_premium ||
            dataSection.basic_premium ||
            0;
    };

    extractTotalPremium = (premiumBreakup, dataSection, polDetails) => {
        return premiumBreakup.final_premium ||
            premiumBreakup.total_premium ||
            dataSection.final_premium ||
            dataSection.total_premium ||
            polDetails.final_premium ||
            polDetails.total_premium ||
            0;
    };

    extractGSTAmount = (premiumBreakup, dataSection, polDetails) => {
        return premiumBreakup.prem_gst ||
            premiumBreakup.gst_amount ||
            premiumBreakup.igst_prem ||
            dataSection.prem_gst ||
            dataSection.gst_amount ||
            polDetails.prem_gst ||
            polDetails.gst_amount ||
            0;
    };

    // Fixed addon change handler for SATP
    handleAddonChange = (addonKey, isChecked) => {
        const addon = Object.values(satpAddonConfig).find(config => config.key === addonKey);

        // Don't allow changing mandatory add-ons
        if (addon && addon.mandatory) {
            this.showToast(`${addon.key} is mandatory for SATP policies`, "warning");
            return;
        }

        this.setState((prevState) => {
            const newAddonValues = { ...prevState.addonValues };
            newAddonValues[addonKey] = isChecked;

            // Clear conditional fields if parent addon is unchecked
            if (!isChecked && addon && addon.conditionalFields) {
                addon.conditionalFields.forEach(field => {
                    delete newAddonValues[field.name];
                });
            }

            return { addonValues: newAddonValues };
        });
    };

    // Fixed conditional field handler
    handleConditionalFieldChange = (fieldName, value) => {
        this.setState((prevState) => ({
            addonValues: {
                ...prevState.addonValues,
                [fieldName]: value,
            },
        }));
    };

    handleBackToQuotes = () => {
        window.location.href = "/mquote";
    };

    handleResetAddons = () => {
        this.setState({
            addonValues: this.initializeMandatorySATPAddons(),
            currentAddons: null,
            isEditMode: false
        });
        sessionStorage.removeItem("currentAddonSelection");
        this.showToast("Add-on selection reset to default", "info");
    };

    renderSATPAddonSelection = () => {
        const { addonValues, plan_type } = this.state;

        // Only show SATP liability covers for Standalone TP policies
        if (!plan_type || !plan_type.includes("Standalone TP")) {
            return (
                <Alert variant="info">
                    Liability add-ons are only available for SATP (Standalone Third Party) policies.
                </Alert>
            );
        }

        return Object.keys(satpAddonConfig).map((addonName, idx) => {
            const addon = satpAddonConfig[addonName];
            const isChecked = addonValues[addon.key] === true;

            return (
                <Card key={idx} className="mb-3">
                    <Card.Body>
                        <div className="d-flex justify-content-between align-items-center">
                            <Form.Check
                                type="checkbox"
                                label={<strong>{addonName}</strong>}
                                checked={isChecked}
                                disabled={addon.mandatory}
                                onChange={(e) => this.handleAddonChange(addon.key, e.target.checked)}
                            />

                            {addon.mandatory && (
                                <span className="badge bg-danger">Mandatory</span>
                            )}
                        </div>

                        {addon.description && (
                            <small className="text-muted d-block mt-1">{addon.description}</small>
                        )}

                        {(isChecked || addon.mandatory) && addon.conditionalFields?.map((field, fidx) => {
                            const showField = typeof field.condition === "function"
                                ? field.condition(addonValues)
                                : field.condition;

                            if (!showField) return null;

                            return (
                                <Form.Group className="mt-3 ms-4" key={fidx}>
                                    <Form.Label>{field.label}</Form.Label>
                                    {field.type === "select" ? (
                                        <Form.Select
                                            value={addonValues[field.name] || field.defaultValue || ""}
                                            onChange={(e) => this.handleConditionalFieldChange(field.name, e.target.value)}
                                        >
                                            <option value="">-- Select --</option>
                                            {field.options?.map((option, oidx) => (
                                                <option key={oidx} value={option}>
                                                    ₹{parseInt(option).toLocaleString()}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    ) : (
                                        <Form.Control
                                            type={field.type}
                                            min={field.min}
                                            max={field.max}
                                            step={field.step}
                                            value={addonValues[field.name] || field.defaultValue || ""}
                                            onChange={(e) => this.handleConditionalFieldChange(field.name, e.target.value)}
                                            placeholder={`Enter ${field.label.toLowerCase()}`}
                                        />
                                    )}
                                    {field.note && (
                                        <Form.Text className="text-muted">{field.note}</Form.Text>
                                    )}
                                </Form.Group>
                            );
                        })}
                    </Card.Body>
                </Card>
            );
        });
    };

    render() {
        const { isSubmittingAddons, isEditMode, quoteDetails } = this.state;

        return (
            <div className="bgalphacolor">
                <h3 className="logoskybluecolor">SATP Liability Add-ons Management</h3>

                {/* Header Alert */}
                <Row className="mb-4">
                    <Col>
                        <Alert variant={isEditMode ? "info" : "primary"}>
                            <h6>{isEditMode ? "Edit Your Current Add-on Selection" : "Select SATP Liability Add-Ons"}</h6>
                            <p className="mb-0">
                                {isEditMode
                                    ? "You can modify your existing add-on selection and get an updated quote."
                                    : "Enhance your SATP policy with additional liability coverage options."
                                }
                            </p>
                        </Alert>
                    </Col>
                </Row>

                {/* Navigation */}
                <Row className="mb-4">
                    <Col>
                        <Button
                            variant="outline-secondary"
                            onClick={this.handleBackToQuotes}
                            className="me-3"
                        >
                            Back to Quotes
                        </Button>
                        {isEditMode && (
                            <Button
                                variant="outline-warning"
                                onClick={this.handleResetAddons}
                                className="me-3"
                            >
                                Reset to Default
                            </Button>
                        )}
                    </Col>
                </Row>

                {/* Quote Summary Card */}
                {quoteDetails && (
                    <Row className="mb-4">
                        <Col>
                            <Card>
                                <Card.Header>
                                    <h6 className="mb-0">Current Quote Summary</h6>
                                </Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col md={3}>
                                            <small><strong>Business Type:</strong> {this.state.business_type}</small>
                                        </Col>
                                        <Col md={3}>
                                            <small><strong>Plan Type:</strong> {this.state.plan_type}</small>
                                        </Col>
                                        <Col md={3}>
                                            <small><strong>Vehicle:</strong> {quoteDetails.vehicle_make} {quoteDetails.vehicle_model}</small>
                                        </Col>
                                        <Col md={3}>
                                            <small><strong>Quote ID:</strong> {quoteDetails.quote_id}</small>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                )}

                {/* Main Content */}
                <Row>
                    <Col lg="8">
                        <Alert variant="info" className="mb-4">
                            <strong>SATP Policy Coverage:</strong> Only liability add-ons are applicable for Standalone Third Party policies.
                            Own Damage add-ons (Return to Invoice, Depreciation, etc.) are not available for SATP.
                        </Alert>

                        <Form>
                            {this.renderSATPAddonSelection()}
                        </Form>
                    </Col>

                    <Col lg="4">
                        <div className="sticky-top">
                            {/* Selected Add-ons Summary */}
                            <Card className="mb-3 shadow-sm">
                                <Card.Header>
                                    <h6 className="mb-0">Selected Liability Add-ons</h6>
                                </Card.Header>
                                <Card.Body>
                                    <ul className="mb-0 list-unstyled">
                                        {Object.keys(this.state.addonValues || {})
                                            .filter(key => this.state.addonValues[key] === true)
                                            .map(key => {
                                                const addon = Object.values(satpAddonConfig).find(config => config.key === key);
                                                const addonName = Object.keys(satpAddonConfig).find(name => satpAddonConfig[name].key === key);
                                                return addon ? (
                                                    <li key={key} className="small mb-1">
                                                        {addon.mandatory ? "🔒" : "✅"} {addonName}
                                                        {addon.mandatory && " (Mandatory)"}
                                                    </li>
                                                ) : null;
                                            })
                                        }
                                        {Object.keys(this.state.addonValues || {}).filter(key =>
                                            this.state.addonValues[key] === true
                                        ).length === 0 && (
                                                <li className="text-muted small">ℹ️ No add-ons selected yet</li>
                                            )}
                                    </ul>
                                </Card.Body>
                            </Card>

                            {/* Action Buttons */}
                            <div className="d-grid gap-2">
                                <Button
                                    type="button"
                                    onClick={this.submitAddonRequest}
                                    variant="primary"
                                    disabled={isSubmittingAddons}
                                    size="lg"
                                >
                                    {isSubmittingAddons ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" />
                                            Processing...
                                        </>
                                    ) : (
                                        "Get Updated SATP Quote"
                                    )}
                                </Button>

                                <Button
                                    type="button"
                                    onClick={this.handleBackToQuotes}
                                    variant="outline-secondary"
                                >
                                    Back to Quotes
                                </Button>
                            </div>

                            {/* Processing Note */}
                            {isSubmittingAddons && (
                                <Alert variant="info" className="mt-3 small">
                                    <strong>⏰ Please wait...</strong><br />
                                    We're calculating your updated premium with the selected liability add-ons.
                                    This may take 10-15 seconds.
                                </Alert>
                            )}
                        </div>
                    </Col>
                </Row>

                {/* Footer Information */}
                <Row className="mt-4">
                    <Col>
                        <Alert variant="info">
                            <h6>ℹ️ SATP (Standalone Third Party) Policy Information</h6>
                            <Row>
                                <Col md={6}>
                                    <ul className="mb-0 small">
                                        <li>SATP covers only Third Party liability - no Own Damage coverage</li>
                                        <li><strong>Mandatory covers:</strong> TPPD (₹6,000) and PA Owner-Driver (₹15,00,000)</li>
                                    </ul>
                                </Col>
                                <Col md={6}>
                                    <ul className="mb-0 small">
                                        <li><strong>Optional liability covers:</strong> PA Paid Driver, PA Passengers, Legal Liability</li>
                                        <li>OD add-ons (Return to Invoice, Depreciation, etc.) are NOT applicable for SATP</li>
                                    </ul>
                                </Col>
                            </Row>
                        </Alert>
                    </Col>
                </Row>
            </div>
        );
    }
}